import React, { useState } from 'react';
import { NodeType } from '../models';
import styles from './NodeDetails.module.scss';

interface Props {
  node: NodeType;
  onClose: () => void;
  onSave: (nodeId: string, context: string) => void;
}

const AppointmentNodeDetails: React.FC<Props> = ({ node, onClose, onSave }) => {
  const data = node.context ? JSON.parse(node.context) : {};
  const [systemType, setSystemType] = useState(data.systemType || '');
  const [schedule, setSchedule] = useState(data.schedule || '');
  const [info, setInfo] = useState(data.info || '');

  const handleSave = () => {
    const json = JSON.stringify({ systemType, schedule, info });
    onSave(node.id, json);
    onClose();
  };

  return (
    <div className={styles.nodeDetails}>
      <h2 className={styles.nodeDetailsTitle}>APPOINTMENT</h2>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>System Type</label>
        <input
          className={styles.nodeDetailsInput}
          value={systemType}
          onChange={e => setSystemType(e.target.value)}
        />
      </div>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Schedule</label>
        <input
          className={styles.nodeDetailsInput}
          value={schedule}
          onChange={e => setSchedule(e.target.value)}
        />
      </div>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Info</label>
        <textarea
          className={styles.nodeDetailsInput}
          value={info}
          onChange={e => setInfo(e.target.value)}
          rows={3}
        />
      </div>
      <div className={styles.nodeDetailsButtons}>
        <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
        <button className={styles.saveButton} onClick={handleSave}>Save</button>
      </div>
    </div>
  );
};

export default AppointmentNodeDetails; 